// When a shopper selects a Color that has no variant for the currently selected Size,
// the theme's native variant-image swap does nothing (no matching variant to switch to).
// This still updates the visible photo to match the chosen Color, using a Color-to-media-id
// map rendered by linked-product-swatches.liquid, purely as a visual fallback — it doesn't
// affect price, availability, or which variant gets added to cart.
(function () {
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches('.variant_name_color')) return;

    const variantRadios = input.closest('variant-radios, variant-selects');
    if (!variantRadios) return;

    const swatchesEl = document.querySelector('linked-product-swatches[data-color-media]');
    if (!swatchesEl) return;

    let colorMedia;
    try {
      colorMedia = JSON.parse(swatchesEl.dataset.colorMedia);
    } catch (e) {
      return;
    }

    // Give the theme's own updateMedia() a turn first; only step in if it had nothing to do.
    window.setTimeout(() => {
      if (variantRadios.currentVariant) return;

      const mediaId = colorMedia[input.value];
      if (!mediaId) return;

      const sectionId = variantRadios.dataset.section;
      const mediaGallery = document.getElementById(`MediaGallery-${sectionId}`);
      if (mediaGallery && mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(`${sectionId}-${mediaId}`, true);
      }
    }, 0);
  });
})();
